import { render } from "./tuesday.vue?vue&type=template&id=2d81c51b"
import script from "./tuesday.vue?vue&type=script&lang=js"
export * from "./tuesday.vue?vue&type=script&lang=js"

import "./tuesday.vue?vue&type=style&index=0&id=2d81c51b&lang=scss"
script.render = render

export default script